/**
 * SearchController — /api/v1/search
 * Mirrors: src/Aidepo.Api/Controllers/SearchController.cs
 *
 * Name search is served by ItemsController (`GET /api/v1/items?q=...`,
 * see endpoints/items.ts → searchItems). This module covers semantic search.
 *
 * UI screen: beads issue hh-7q2 (Phase 2.5).
 */
import { apiPost } from '../client.js';
import type { Uuid } from '../types.js';

export interface SemanticSearchRequest {
  readonly query: string;
}

export interface SemanticSearchHit {
  readonly itemId: Uuid;
  readonly name: string;
  readonly locationLabel: string;
  readonly reason: string;
  /** Manually picked icon name, or null/undefined for auto-resolve (hh-345). */
  readonly icon?: string | null;
}

export interface SemanticSearchResponse {
  readonly query: string;
  /**
   * Resolution path the backend took. Currently `"lexical_fallback"` until the
   * agent-backed path lands — callers should NOT special-case the value.
   */
  readonly mode: string;
  readonly results: readonly SemanticSearchHit[];
}

/** POST /api/v1/search/semantic — natural-language item lookup. */
export function semanticSearch(query: string): Promise<SemanticSearchResponse> {
  return apiPost<SemanticSearchResponse, SemanticSearchRequest>(
    '/api/v1/search/semantic',
    { query },
  );
}
